<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            @action="masterAction"
            modalWidth="90%"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('Encargado')"
                    :formItemConfig="fiOptions"
                    ref="empleado"
                    endpoint="empleados"
                    :decorator="['id_emp', { rules: [{ required: false, message: 'Valor requerido' }] }]"
          >
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Origen')"
                      style="width: 100%"
                      :formItemConfig="fiOptions"
                      :decorator="['origin', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                      :params="origin_recommend">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha recomendación')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['date_recom_cases', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Observaciones')" v-bind="fiOptions">
            <a-textarea autoSize
                        v-decorator="['obs_recom_cases', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha de vigencia')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['validity_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['id_case'],
    data () {
      return {
        origin_recommend: {
          h_lookup_type: 'ORIGIN_RECOMMEND',
          use_code: true
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'recommend_case',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_recom_cases'
            },
            columns: [
              {title: 'Id encargado', dataIndex: 'id_emp', sorter: true},
              {title: 'Encargado', dataIndex: 'full_name', sorter: true},
              {title: 'Origen', dataIndex: 'desorigin', sorter: true},
              {title: 'Fecha recomendación', dataIndex: 'date_recom_cases_desc', sorter: true},
              {title: 'Fecha de vigencia', dataIndex: 'validity_date_desc', sorter: true},
              {title: 'Observación', dataIndex: 'obs_recom_cases', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'date_recom_cases'},
            {name: 'obs_recom_cases'},
            {name: 'origin'},
            {name: 'id_emp'},
            {name: 'validity_date'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.id_t_legal_entity = action.record.id_t_legal_entity
            this.$nextTick(() => {
              if (!this.$isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            break
        }
      }
    },
    computed: {
      parentData () {
        return {id_case: this.id_case}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/RecommendCase.vue